import React from 'react'

import checkmarkActive from '../../../images/checkmark-active.png'
import redCross from '../../../images/red-cross.png'

const ChartAccuracy = ({ chart }) => {
  const { completedHandsAllTime, mistakenHandsAllTime } = chart

  const handsCountAllTime = Object.values(completedHandsAllTime).reduce(
    (acc, curr) => {
      return parseInt(acc) + parseInt(curr)
    },
    0,
  )

  const mistakesCountAllTime = Object.values(mistakenHandsAllTime).reduce(
    (acc, curr) => {
      return parseInt(acc) + parseInt(curr)
    },
    0,
  )

  const successCountAllTime = handsCountAllTime - mistakesCountAllTime

  const uniqueHandsLength = Object.values(completedHandsAllTime).reduce(
    (acc, curr) => {
      return 1 + acc
    },
    0,
  )

  const uniqueMistakesLength = Object.values(mistakenHandsAllTime).reduce(
    (acc, curr) => {
      return 1 + acc
    },
    0,
  )
  const uniqueSuccessLength = uniqueHandsLength - uniqueMistakesLength

  const rowStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px',
    display: 'flex',
    width: '100%',
  }

  const textStyle = {
    fontSize: '16px',
    display: 'flex',
  }

  return (
    <div
      style={{
        border: '2px solid black',
        borderRadius: 8,
        backgroundColor: 'rgba(0,200,255,0.1)',
        alignItems: 'center',
        padding: '10px 10px 5px 5px',
        margin: '20px 0',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={rowStyle}>
        <div
          style={{
            width: '20px',
            margin: `0 20px`,
          }}
        />
        <div
          className="ClearTheCharts__stats-label"
          style={{ ...textStyle, fontWeight: '600' }}
        >
          Total hands
        </div>
        <div
          className="ClearTheCharts__stats-label"
          style={{ ...textStyle, fontWeight: '600' }}
        >
          Unique hands
        </div>
      </div>
      <div style={rowStyle}>
        <img
        alt="checkmark"
          src={checkmarkActive}
          style={{
            height: 19,
            width: 19,
            margin: `0 20px`,
          }}
        />
        <div className="ClearTheCharts__stats-label" style={textStyle}>
          {successCountAllTime} / {handsCountAllTime} (
          {Math.round(
            (successCountAllTime / handsCountAllTime).toFixed(2) * 100,
          )}
          %)
        </div>
        <div className="ClearTheCharts__stats-label" style={textStyle}>
          {uniqueSuccessLength} / {uniqueHandsLength} (
          {Math.round(
            (uniqueSuccessLength / uniqueHandsLength).toFixed(2) * 100,
          )}
          %)
        </div>
      </div>
      <div style={rowStyle}>
        <img
          alt="mistake"
          src={redCross}
          style={{
            height: 19,
            width: 19,
            margin: `0 20px`,
          }}
        />
        <div className="ClearTheCharts__stats-label" style={textStyle}>
          {mistakesCountAllTime} / {handsCountAllTime} (
          {Math.round(
            (mistakesCountAllTime / handsCountAllTime).toFixed(2) * 100,
          )}
          %)
        </div>
        <div className="ClearTheCharts__stats-label" style={textStyle}>
          {uniqueMistakesLength} / {uniqueHandsLength} (
          {Math.round(
            (uniqueMistakesLength / uniqueHandsLength).toFixed(2) * 100,
          )}
          %)
        </div>
      </div>
    </div>
  )
}

export default ChartAccuracy
